import React from "react";

function UpArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      transform="rotate(180)"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="#5C5C5C"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UpArrowIcon;
